import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { InputElementBase } from '../utils/types';
import GenericFormInput from './GenericFormInput';

export default function FormInput({
  label,
  description,
  className,
  disabled,
  placeholder,
  name,
  onBlur,
  onChange,
  ref,
  value,
  icon,
  type = 'text',
  autoComplete,
}: InputElementBase) {
  return (
    <FormItem className={className || undefined}>
      {label && <FormLabel>{label}</FormLabel>}
      <FormControl>
        <div className="relative">
          <GenericFormInput
            type={type}
            placeholder={placeholder || undefined}
            disabled={disabled}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            ref={ref}
            value={value}
            autoComplete={autoComplete}
          />
          {icon && <span className="absolute right-4 top-4">{icon}</span>}
        </div>
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  );
}
